module.exports = __webpack_public_path__ + "img/photo-0092.f9b75eb9.jpg";